module.exports = __webpack_public_path__ + "img/Westminster_Foundation_Website_Header_Logo_WF_Wordmark.b3301196.svg";